@if (show) {
    <div class="ur-spinner-overlay" data-cy="spinner-overlay">
        <div class="ur-spinner" data-cy="spinner">
            <div class="ur-spinner-circle"></div>
            <svg class="ur-spinner-arc" width="64" height="64" viewBox="0 0 64 64">
                <circle class="ur-spinner-arc-path" cx="32" cy="32" r="28" fill="none" />
            </svg>
        </div>
    </div>
}
